module.exports = __webpack_public_path__ + "static/img/309_TO8_2296_og.4cd8e85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/309_TO8_2296_og.jpg
// module id = IDYm
// module chunks = 0